const propyCookieValue = (state = '{}', action) => {
  switch (action.type) {
      case 'SET_PROPY_COOKIE_VALUE':
          return action.cookieValue
      default:
          return state
  }
}

export default propyCookieValue;